import React from 'react';
import { Form } from '@formio/react';
import 'formiojs/dist/formio.full.min.css';
import './index.css';
import './custom-formio-arabic-style.css';

function App() {
  const handleSubmit = async (submission) => {
    alert('✅ تم الإرسال!');
    console.log('Form submission:', submission);

    try {
      const response = await fetch('https://n8n.rai-consult.com/webhook-test/formio-submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(submission.data)
      });

      if (response.ok) {
        console.log('📡 Webhook sent successfully');
      } else {
        console.error('❌ Webhook failed:', response.status);
      }
    } catch (error) {
      console.error('❌ Webhook error:', error);
    }
  };

  return (
    <div className="form-wrapper min-h-screen bg-gray-100 py-10 px-4">
      <div className="max-w-4xl mx-auto bg-white shadow-xl rounded-xl p-10">
        <h2 className="text-2xl font-bold mb-4 text-right">🍽️ شو أطبخ اليوم؟</h2>
        <Form
          src="https://form.rai-consult.com/whatToCook"
          onSubmit={handleSubmit}
          options={{
            language: 'ar',
            i18n: {
              ar: {
                next: 'التالي',
                previous: 'السابق',
                submit: 'إرسال',
                cancel: 'إلغاء',
              }
            }
          }}
        />
      </div>
    </div>
  );
}

export default App;
